import { get } from 'helpers/api';
import types from './types';

// Fields
export const getFieldsIfNotLoaded = () => {
  return (dispatch, getState) => {
    const { isFieldsLoaded, isFieldsLoading } = getState().add;

    if (!isFieldsLoaded && !isFieldsLoading) {
      return dispatch(getFields());
    } else {
      return false;
    }
  };
};

export const getFields = () => {
  return dispatch =>
    get('insight/dictionary', {
      data: {},
      before: () => dispatch(getFieldsStart()),
      success: fields => dispatch(getFieldsSuccess(fields)),
    });
};

const getFieldsStart = () => {
  return {
    type: types.GET_FIELDS_START,
  };
};

const getFieldsSuccess = fields => {
  return {
    type: types.GET_FIELDS_SUCCESS,
    fields,
  };
};



// WEBPACK FOOTER //
// state/add/actions.js